import { CoreIcon } from '../core-icon';
import arrowLeftCircleFillSVG from '../../assets/icons/arrow-left-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ArrowLeftCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowLeftCircleFillSVG} {...props} />;
};
